let Util = {
//金钱格式化，去除首位的0，保留小数点后两位的0
  prefixExcpet0:function(x)
{
  x = (x + '').replace(/^0+\./g, '0.');
  x.match(/^0+[1-9]+/) ? x = x.replace(/^0+/g, '') : x;
  x = Number(x) ? x : 0;
  return x;
},
  //阿拉伯数字转换成大写汉字
  numberParseChina:function(money)
{
 if(money==null){
   return ''
 }
//汉字的数字
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
  //基本单位
  var cnIntRadice = new Array('', '拾', '佰', '仟');
  //对应整数部分扩展单位
  var cnIntUnits = new Array('', '万', '亿', '兆');
  //对应小数部分单位
  var cnDecUnits = new Array('角', '分', '毫', '厘');
  //整数金额时后面跟的字符
  var cnInteger = '整';
  //整型完以后的单位
  var cnIntLast = '圆';
  //最大处理的数字
  var maxNum = 999999999999999.9999;
  //金额整数部分
  var integerNum;
  //金额小数部分
  var decimalNum;
  //输出的中文金额字符串
  var chineseStr = '';
  //分离金额后用的数组，预定义
  var parts;
  if (money == '') {
    return '';
  }
  money = parseFloat(money);
  let isFushu =false;//是否负数
  if(money<0){
    isFushu=true;
    money=parseFloat(money.toString().split("-")[1])
  }
  if (money >= maxNum) {
    //超出最大处理数字
    return '';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  //转换为字符串
  money = money.toString();
  if (money.indexOf('.') == -1) {
    integerNum = money;
    decimalNum = '';
  } else {
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != '') {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '') {
    chineseStr += cnInteger;
  }
  if(isFushu){
    chineseStr='负'+chineseStr
  }
  return chineseStr;
},
  /**
   * 把Number四舍五入为指定小数位数的数字字符串（解决原toFixed四舍五入问题）
   * @param {number} [len=0] 保留小数位数
   * @param {boolean} [round=true] 是否四舍五入（默认进行四舍五入）
   * @param {boolean} [padding=true] 有效数字不足预设小数位数时是否后补0（默认后补）如：_toFixed(1.1,3,true,true) = "1.100"  ;   _toFixed(1.1,3,true,false) = "1.1"
   * @returns {string}
   * @example _toFixed(1.335,2);
   */
   _toFixed:function(num, len, round, padding) {
  num = Number(num);
  if (len < 0) {
    throw new RangeError("digits argument must be between 0 and 100");
  }
  let numStr = String(num), //数字转字符串
    pointIndex = numStr.indexOf("."); //小数点下标
    if(pointIndex<0){
      return num
    }
   let preNumIndex = pointIndex + len + 1; //保留位后一位数字下标
  if (numStr.includes("e") || pointIndex === -1) {
    //遇到科学表示法或整数，直接返回原生toFixed处理结果
    return num.toFixed(len);
  }
  let addZeroCount = len - (numStr.length - pointIndex - 1); //需补0的个数
  if (addZeroCount > 0) {
    numStr += "0".repeat(addZeroCount); //小数位不足后补0
  }
  let numCut = Math.abs(numStr.substring(0, preNumIndex)); //截取保留位（含）前的所有字符
  let res =
    (num < 0 ? "-" : "") +
    (round && numStr[preNumIndex] >= 5
        ? numCut + 1 / Math.pow(10, len)
        : numCut
    ).toFixed(len); //判断预期小数位后一位是否大于等于5，是则进位
  return padding ? res : String(Number(res));
},
  /***
   * 将任意数量对象或者字符串传入该方法，若有任意一个为空，则返回true
   * 可判断 空对象 空数组 空字符串 undefined null
   * @returns {boolean}
   */
  isEmpty: function (){
    let len = arguments.length;
    if(len===0){ return true; }
    for(let i=0;i<len;i++){
      let a = arguments[i];
      if(typeof a === "undefined" || a == null || (typeof a === "string" && a.trim() === "")){
        return true;
      }else if(typeof a === "object"){
        let flg = true;
        for (let k in a ) {
          flg=false;
          break;
        }
        if(flg){ return true; }
      }
    }
    return false;
  },
  isFunction: function(fn) {
    return typeof fn === "function" && typeof fn.nodeType !== "number";
  },
  isPlainObject: function( obj ) {
    let proto, Ctor, class2type = {}, toString = class2type.toString, hasOwn = class2type.hasOwnProperty, fnToString = hasOwn.toString, ObjectFunctionString = fnToString.call( Object );
    if ( !obj || toString.call( obj ) !== "[object Object]" ) {
      return false;
    }
    proto = Object.getPrototypeOf( obj );
    if ( !proto ) {
      return true;
    }
    Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
    return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
  },
  isInteger: function(obj) {
    return typeof obj === 'number' && obj%1 === 0;
  },
  extendCopy:function(s,t) {
    for (let i in t) {
      if(!this.isEmpty(s[i]))
        t[i] = s[i];
    }
  },
  /***
   * 对象扩展，支持深拷贝
   * 参数：[deep],target,object1,[objectN]
   */
  extend:function() {
    let options, name, src, copy, copyIsArray, clone, target = arguments[ 0 ] || {}, i = 1, length = arguments.length, deep = false;
    // 如果第一个参数是布尔类型，则判断是否是深拷贝
    if ( typeof target === "boolean" ) {
      deep = target;
      // 如果是深拷贝，则取出第二个参数作为target
      target = arguments[ i ] || {};
      i++;
    }
    // Handle case when target is a string or something (possible in deep copy)
    if ( typeof target !== "object" && !Util.isFunction( target ) ) {
      target = {};
    }
    for ( ; i < length; i++ ) {
      if ( ( options = arguments[ i ] ) != null ) {
        for ( name in options ) {
          src = target[ name ];
          copy = options[ name ];
          // 如果两者完全一样就跳出当前循环，防止死循环
          if ( target === copy ) {
            continue;
          }
          // 只处理普通对象和数组类型
          if ( deep && copy && ( Util.isPlainObject( copy ) ||
              ( copyIsArray = Array.isArray( copy ) ) ) ) {
            if ( copyIsArray ) {
              copyIsArray = false;
              clone = src && Array.isArray( src ) ? src : [];
            } else {
              clone = src && Util.isPlainObject( src ) ? src : {};
            }
            // 递归扩展
            target[ name ] = Util.extend( deep, clone, copy );
          } else if ( copy !== undefined ) {
            target[ name ] = copy;
          }
        }
      }
    }
    return target;
  },
  /***
   * 批量修改对象中日期格式，将时间戳修改为日期字符串
   * item为对象，keys为对象中需要修改的key，format为日期格式
   */
  dateToString: function (item,keys,format) {
    format = this.isEmpty(format)?"yyyy-MM-dd HH:mm:ss":format
    for(let i=0;i<keys.length;i++){
      if(!this.isEmpty(item[keys[i]])){
        item[keys[i]] = new Date(item[keys[i]]).format(format);
      }
    }
  },
  stringToInt: function (item,keys) {
    for(let i=0;i<keys.length;i++){
      if(!this.isEmpty(item[keys[i]])){
        item[keys[i]] = parseInt(item[keys[i]]);
      }
    }
  },
  /***
   * 批量修改对象中数字格式，将数字修改为金额格式
   * item为对象，keys为对象中需要修改的key，n为小数点保留位数
   */
  numberFormat:function(item,keys,n){
    n = this.isEmpty(n)?"2":n
    for(let i=0;i<keys.length;i++){
      let num = item[keys[i]];
      n = n > 0 && n <= 20 ? n : 2;
      num = parseFloat((num + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
      let l = num.split(".")[0].split("").reverse(), r = num.split(".")[1],t = "";
      for (let j = 0; j < l.length; j++) {
        t += l[j] + ((j + 1) % 4 === 0 && (j + 1) !== l.length ? "," : "");
      }
      item[keys[i]] = t.split("").reverse().join("") + "." + r;
    }
  },
  checkIDCard: function(rule, value, callback) {
    setTimeout(function(){
      if (!value) {
        return callback(new Error('请输入身份证号码'));
      }
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if(reg.test(value) === false){
        return callback(new Error('输入的身份证号码无效'));
      }
      callback();
    }, 200);
  },
  checkPhone: function(rule, value, callback) {
    setTimeout(function(){
      if (!value) {
        return callback(new Error('请输入联系方式'));
      }
      let reg = /^1[3|4|5|7|8][0-9]{9}$/;
      if(reg.test(value) === false){
        return callback(new Error('输入的手机号码无效'));
      }
      callback();
    }, 200);
  },
  checkUsername: function(rule, value, callback) {
    setTimeout(function(){
      let reg_first = /^[a-zA-Z_-]$/,reg = /^[a-zA-Z_-]([a-zA-Z0-9_.-]){5,19}$/;
      if (!value) {
        return callback(new Error('请输入用户名'));
      }else if(reg_first.test(value.substr(0,1)) === false){
        return callback(new Error('请输入以a-zA-Z_-开头的内容'));
      }else if(value.length < 6){
        return callback(new Error('用户名最小长度为6'));
      }else if(value.length > 20){
        return callback(new Error('用户名最大长度为20'));
      }else if(reg.test(value) === false){
        return callback(new Error('输入内容只能包含a-zA-Z0-9_.-'));
      }
      callback();
    }, 200);
  },
  checkNumber: function(rule, value, callback) {
    setTimeout(function(){
      if(rule.required && !value){
        return callback(new Error(rule.requiredMessage));
      }
      if(value){
        let reg = /^[1-9]\d*$/;
        if(reg.test(value) === false){
          return callback(new Error(rule.invalidMessage));
        }
      }
      callback();
    }, 200);
  }
};

Array.prototype.indexOf = function(val) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == val) return i;
  }
  return -1;
};

Array.prototype.remove = function(val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};

/**
 * 扩展DATE属性，增加日期格式化方法
 * @param f
 * @returns {*}
 */
Date.prototype.format = function(f){
  let o ={
    "M+" : this.getMonth()+1, //month
    "d+" : this.getDate(),    //day
    "H+" : this.getHours(),   //hour
    "m+" : this.getMinutes(), //minute
    "s+" : this.getSeconds(), //second
    "q+" : Math.floor((this.getMonth()+3)/3),  //quarter
    "S" : this.getMilliseconds() //millisecond
  };
  if(/(y+)/.test(f))f=f.replace(RegExp.$1,(this.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(let k in o)
    if(new RegExp("("+ k +")").test(f))f = f.replace(RegExp.$1,RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));return f
};

export default
{Util:Util}



// WEBPACK FOOTER //
// ./src/utils/util.js